import { Dialog, DialogActions, DialogContent, DialogTitle, Divider } from "@material-ui/core";
import * as React from "react";
import { Button } from "react-admin";
import { useAuth } from "@airborne/react-admin";
import DOMPurify from "dompurify";
import { useEffect } from "react";

const ExperienceSoftWarningDialog = props => {
  const { user } = useAuth();
  const [open, setOpen] = React.useState(false);
  const hasShownRef = React.useRef(false);

  useEffect(() => {
    if (hasShownRef.current) return;

    var experience = props?.data?.filter(x => x.noteType == props.type)[0];

    if ((!user?.isCustomer && experience?.isShownTt) || (user?.isCustomer && experience?.isShownCustomer)) {
      hasShownRef.current = true;
      setOpen(true);
    }
  }, [props?.data, props?.type, user]);

  const handleClose = () => setOpen(false);

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle id="alert-dialog-title">EXPERIENCE WARNING</DialogTitle>
      <Divider />
      <DialogContent>
        <div
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(props?.data?.find(x => x.noteType === props.type)?.remark ?? ""),
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} label="Close" />
      </DialogActions>
    </Dialog>
  );
};

export default ExperienceSoftWarningDialog;
